import { ClockIcon, CornersOutIcon } from '@phosphor-icons/react';
import { SecurityCameraIconMirrored } from '@/utils/icons';
import { formatDate } from '@/utils/date';
import type { DirectoryItemInfoField } from './components/DirectoryItemInfoPanel';

const iconClass = 'w-4 h-4 text-grey-300 shrink-0';

interface EntityAnalyticsParams {
    firstSeen: number;
    lastSeen: number | undefined;
    totalEvents: number;
    totalSources: number;
}

export function buildEntityAnalyticsFields(
    t: (key: string) => string,
    { firstSeen, lastSeen, totalEvents, totalSources }: EntityAnalyticsParams,
): DirectoryItemInfoField[] {
    return [
        {
            title: t('vehiclePage.analytics.detected'),
            value: `${totalEvents} ${t('vehiclePage.analytics.times')}`,
            icon: <CornersOutIcon className={iconClass} />,
        },
        {
            title: t('vehiclePage.analytics.across'),
            value: `${totalSources} ${t('vehiclePage.analytics.sources')}`,
            icon: <SecurityCameraIconMirrored className={iconClass} />,
        },
        {
            title: t('vehiclePage.analytics.firstSeen'),
            value: formatDate(firstSeen),
            icon: <ClockIcon className={iconClass} />,
        },
        {
            title: t('vehiclePage.analytics.lastSeen'),
            value: lastSeen ? formatDate(lastSeen) : '—',
            icon: <ClockIcon className={iconClass} />,
        },
    ];
}
